import React, { useState, useEffect } from "react";
import { PhoneVerificationService } from "app/services";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { VerificationModel } from "app/models";

type PropsDef = {
  phone?: string;
  phoneCountry?: string;
  verificationId?: string;
};

type ErrorType =
  | "phone_verification_unprocessable_entity"
  | "phone_verification_unknown"
  | null;

const ResendButton = (props: PropsDef) => {
  const { t } = useTranslation();
  const { phone, phoneCountry, verificationId } = props;

  const [canResend, setCanResend] = useState(false);
  const [verifId, setVerifId] = useState(props.verificationId || null);
  const [error, setError] = useState<ErrorType>(null);

  useEffect(() => {
    if (!verificationId) {
      console.warn("No verification ID provided for polling");
      return undefined;
    }

    startPolling(verifId);
  }, [verifId]);

  const startPolling = (id: string) => {
    setError(null);

    (PhoneVerificationService as any)
      .pollCanResendCode(id)
      .then((response: any) => {
        console.log("response: ", response);
        if (response.canRetry === true) {
          setCanResend(true);
        }
      })
      .catch((err: any) => {
        console.error("Polling error:", err);
      });
  };

  const onResendClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (!canResend) {
      return;
    }

    setError(null);
    setCanResend(false);

    (PhoneVerificationService as any)
      .verify(phone, phoneCountry)
      .then((res: VerificationModel) => {
        if (res.id) {
          setVerifId(res.id);
        }
      })
      .catch(
        (
          err:
            | "phone_verification_unprocessable_entity"
            | "phone_verification_unknown",
        ) => {
          setCanResend(true);
          setError(err);
        },
      );
  };

  return (
    <div className={styles.resendCodeButton}>
      {canResend ? (
        <>
          {t("Didn't get the code?")}&nbsp;
          <a onClick={onResendClick} style={{ cursor: "pointer" }}>
            {t("Resend")}
          </a>
        </>
      ) : (
        <span>
          {t("Didn't get the code? You'll be able to resend it shortly.")}
        </span>
      )}
      <br />
      {error !== null ? (
        <span className={styles.error}>{t("Something went wrong.")}</span>
      ) : (
        ""
      )}
    </div>
  );
};

export default ResendButton;
